import { RxEyeClosed, RxEyeOpen } from 'react-icons/rx';
import { useState, forwardRef } from 'react';
import './Input.scss';

export type InputProps = {
    label?: string;
    placeholder?: string;
    name: string;
    icon?: JSX.Element;
    className?: string;
    type?: string;
    value?: string | number;
    rightContent?: React.ReactNode;
    readOnly?: boolean;
    required?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({
    label,
    readOnly = false,
    name,
    value,
    type = 'text',
    rightContent,
    placeholder,
    required = false,
    onChange,
    onBlur,
    className,
    ...props
}, ref) => {
    const [isFocused, setIsFocused] = useState(false);
    const [isPasswordShown, setIsPasswordShown] = useState(false);

    const isPassword = type === 'password';

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        setIsFocused(false);
        if (onBlur) {
            onBlur(e);
        }
    };

    return (
        <div className={`input-wrapper ${isFocused ? 'focused' : ''} ${(value != null && value !== '') || type === 'datetime-local' ? 'has-value' : ''} ${readOnly ? 'disabled' : ''}`}>
            <label className="input-label">{label} {(required && !readOnly) && <>*</>}</label>
            <input
                ref={ref}
                id={name}
                name={name}
                placeholder={placeholder ?? ''}
                value={(value == null || value == undefined) ? '' : value}
                required={required}
                className={`input-field ${className} ${readOnly ? 'disabled' : ''}`}
                type={isPassword ? (isPasswordShown ? 'text' : 'password') : type}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={onChange}
                disabled={readOnly}
                {...props}
            />
            {rightContent && <span className="right-content">{rightContent}</span>}
            {isPassword && (
                <span className="toggle-password" onClick={() => setIsPasswordShown(!isPasswordShown)}>
                    {isPasswordShown ? <RxEyeClosed /> : <RxEyeOpen />}
                </span>
            )}
        </div>
    );
});
